export enum InvestableType {
    Instrument =	1,
    ModelPortfolio = 2
}